import {StyleSheet} from 'react-native';
import Sizes from 'Sizes';

export const backgroundColor = '#FFF';

export default StyleSheet.create({
  headerContainerStyle: {
    borderBottomColor: 'rgba(0, 0, 0, 0.2)',
    justifyContent: 'center',
    borderBottomWidth: 1,
  },
  titleStyle: {
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
    ...Sizes.select({
      phone: {
        fontSize: 20,
      },
      tablet: {
        fontSize: 22,
      },
    }),
  },

  leftIcon: {
    height: 18,
    width: 25,
    top: 3,
  },

  rightIcon: {
    height: 18,
    width: 18,
    marginRight: 16,
  },

  smsContainerStyle: {
    top: 60,
  },
});
